import { ReactNode } from "react";
import { useDroppable } from "@dnd-kit/core";
import { twMerge } from "tailwind-merge";

/** Звено панели уровней: папка или корень, куда можно бросить узел. */
export function LevelDropLink({
  id,
  icon,
  title,
  current,
  dropTarget,
}: {
  id: string;
  icon: ReactNode;
  title: string;
  /** Узел уже лежит здесь — бросок сюда ничего не изменит. */
  current: boolean;
  dropTarget: boolean;
}) {
  const { setNodeRef } = useDroppable({ id });

  return (
    <span
      ref={setNodeRef}
      title={title}
      className={twMerge(
        "flex min-h-12 min-w-0 max-w-60 items-center gap-2 rounded-lg border border-dashed px-3",
        "border-[--palette-neutral-4] text-base",
        current && "border-transparent text-[--palette-neutral-6]",
        dropTarget &&
          "border-solid border-[--palette-success-5] bg-[--palette-success-1]",
      )}
    >
      <span className="shrink-0 text-lg">{icon}</span>
      <span className="truncate">{title}</span>
    </span>
  );
}
